import React from 'react';
import { Copy, Check, Edit3, RotateCcw, Save, X } from 'lucide-react';

const ChatMessage = ({ 
  message, 
  index,
  editingMessageId,
  editingContent,
  setEditingContent,
  editMessage,
  cancelEditMessage,
  isLoading,
  startEditMessage,
  rollbackToMessage,
  copyMessage,
  copiedMessageId 
}) => {
  return (
    <div className={`message message-${message.role}`}>
      {editingMessageId === message.id ? (
        // 編集モード
        <div className="message-content-full">
          <div className="message-editing">
            <textarea
              value={editingContent}
              onChange={(e) => setEditingContent(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && e.ctrlKey) {
                  e.preventDefault();
                  editMessage(message.id, editingContent);
                } else if (e.key === 'Escape') {
                  e.preventDefault();
                  cancelEditMessage();
                }
              }}
              className="edit-textarea"
              rows={3}
              style={{
                minHeight: '80px',
                maxHeight: '200px',
                resize: 'vertical',
                width: '100%'
              }}
              autoFocus
            />
            <div className="edit-actions">
              <button
                onClick={() => editMessage(message.id, editingContent)}
                disabled={!editingContent.trim() || isLoading}
                className="btn btn-primary btn-sm"
              >
                <Save className="icon-xs" />
                保存 (Ctrl+Enter)
              </button>
              <button
                onClick={cancelEditMessage}
                className="btn btn-secondary btn-sm"
              >
                <X className="icon-xs" />
                キャンセル
              </button>
            </div>
          </div>
        </div>
      ) : (
        // 通常表示モード
        <div className="message-wrapper">
          <div className="message-content-main">
            <div className="message-text">{message.content}</div>
          </div>
          <div className="message-actions-sidebar">
            {message.role === 'user' && (
              <button
                onClick={() => startEditMessage(message)}
                className="action-btn-modern edit-btn"
                title="メッセージを編集"
              >
                <Edit3 className="icon-xs" />
              </button>
            )}
            {index > 0 && (
              <button
                onClick={() => rollbackToMessage(message.id)}
                className="action-btn-modern rollback-btn"
                title="ここまでロールバック"
              >
                <RotateCcw className="icon-xs" />
              </button>
            )}
            {message.role === 'assistant' && (
              <button 
                onClick={() => copyMessage(message)} 
                className="action-btn-modern copy-btn"
                title="コピー"
              >
                {copiedMessageId === message.id ? (
                  <Check className="icon-xs" />
                ) : (
                  <Copy className="icon-xs" />
                )}
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatMessage;